<template>
  <div>
    <!-- 文字信息 -->
    <div class="test-info">
      <p class="test-1">If you have any question，connect us by email</p>
      <p class="test-2">{{email}}</p>
    </div>
  </div>
</template>

<script>
  import {encryption} from "../utils/requestUtils";

  export default{
    data(){
      return {
        email:"",
        Params:""
      }
    },
    mounted(){
      this.getEmail()
    },
    methods:{
      getEmail() {
        this.Params = this.$route.query
        this.axios.post('/api/order/paymentStatus', {
          requestParam: encryption({
            merchantId: this.Params.merchantId,
            merchantOrderId: this.Params.merchantOrderId
          })
        }).then(res => {
            this.email = res.data.data.logoEmail;
        })
      },
    }
  }
</script>

<style lang="scss">
  .test-info{
    margin-top: 0.32rem;
    .test-1{
      font-size: 0.26rem;
      font-family: PingFang-SC-Medium, PingFang-SC;
      font-weight: 500;
      color: #282E34;
    }
    .test-2{
      font-size: 0.26rem;
      font-family: PingFang-SC-Bold, PingFang-SC;
      font-weight: bold;
      color: #39B549;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/emailtext.vue